var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0006C14.7614 12.0006 17 9.76203 17 7.00061C17 4.23919 14.7614 2.00061 12 2.00061C9.23858 2.00061 7 4.23919 7 7.00061C7 9.76203 9.23858 12.0006 12 12.0006Z",
    fill: "#026F30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.5006C6.98991 14.5006 2.90991 17.8606 2.90991 22.0006C2.90991 22.2806 3.12991 22.5006 3.40991 22.5006H20.5899C20.8699 22.5006 21.0899 22.2806 21.0899 22.0006C21.0899 17.8606 17.0099 14.5006 11.9999 14.5006Z",
    fill: "#026F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserName);
export default __webpack_public_path__ + "static/media/user-name.d8821146abc0ed8f1cc5ac0b4c035a2b.svg";
export { ForwardRef as ReactComponent };